module.exports = __webpack_public_path__ + "static/media/shop01.ec0887ab.png";